const DEFAULT_ENVIRONMENT = 'qa';
const DEFAULT_VERSION = '1.37.0';
const DEFAULT_SESSION_DURATION_MS = 24 * 60 * 60 * 1000;

const sharedConfig = {
    appName: 'BackOffice Web',
    captchaKey: '6LdJ9TcpAAAAAD2NlLy3kdh6VwhGbHBJZFPAixPB',
    cryptoKey: 'GjtHYIj+UNM0eyLVxuJYxvoedLc/Jz4Cieo4xU+vruQ=',
    cryptoIv: 'NZbMuA0Wqcsp6RjY6z7X6w==',
    version: process.env.REACT_APP_VERSION || DEFAULT_VERSION,
    sessionDurationMs: Number(process.env.REACT_APP_SESSION_DURATION_MS) || DEFAULT_SESSION_DURATION_MS,
    sessionInactivityMs: Number(process.env.REACT_APP_SESSION_INACTIVITY_MS) || DEFAULT_SESSION_DURATION_MS
};

const environmentConfig = {
    qa: {
        environment: 'qa',
        appUrl: 'https://backoffice-qa.mystratis.com/',
        gatewayUrl: 'https://api-qa.mystratis.com/stratis-web-v1.0/',
        recruitmentCommentsGatewayUrl: 'https://api-qa.mystratis.com/stratis-web-v1.0/'
    },
    uat: {
        environment: 'uat',
        appUrl: 'https://backoffice-uat.mystratis.com/',
        gatewayUrl: 'https://api-uat.mystratis.com/stratis-web-v1.0/',
        recruitmentCommentsGatewayUrl: 'https://api-uat.mystratis.com/stratis-web-v1.0/'
    },
    production: {
        environment: 'production',
        appUrl: 'https://backoffice.mystratis.com/',
        gatewayUrl: 'https://api.mystratis.com/stratis-web-v1.0/',
        recruitmentCommentsGatewayUrl: 'https://api.mystratis.com/stratis-web-v1.0/'
    }
};

const environmentAliases = {
    dev: 'qa',
    local: 'qa',
    development: 'qa',
    prod: 'production'
};

const normalizeEnvironment = value => {
    const environment = String(value || '').trim().toLowerCase();
    return environmentAliases[environment] || environment;
};

const getEnvironmentFromSearchParams = search => {
    const params = new URLSearchParams(search || '');
    return normalizeEnvironment(
        params.get('environment') ||
        params.get('env')
    );
};

const matchesHostnameToken = (hostname, token) => {
    const normalizedHostname = String(hostname || '').toLowerCase();

    return normalizedHostname === token ||
        normalizedHostname.includes(`-${token}`) ||
        normalizedHostname.includes(`${token}-`) ||
        normalizedHostname.includes(`.${token}`) ||
        normalizedHostname.includes(`${token}.`);
};

const getEnvironmentFromHostname = hostname => {
    const normalizedHostname = String(hostname || '').toLowerCase();

    if (!normalizedHostname ||
        normalizedHostname === 'localhost' ||
        normalizedHostname === '127.0.0.1' ||
        normalizedHostname === '0.0.0.0') {
        return 'qa';
    }

    if (matchesHostnameToken(normalizedHostname, 'uat')) {
        return 'uat';
    }

    if (matchesHostnameToken(normalizedHostname, 'qa')) {
        return 'qa';
    }

    if (normalizedHostname === 'backoffice.mystratis.com' ||
        normalizedHostname === 'www.backoffice.mystratis.com') {
        return 'production';
    }

    return DEFAULT_ENVIRONMENT;
};

const getRuntimeEnvironment = () => {
    if (typeof window === 'undefined') {
        return {
            environment: normalizeEnvironment(process.env.REACT_APP_ENVIRONMENT) || DEFAULT_ENVIRONMENT,
            source: process.env.REACT_APP_ENVIRONMENT ? 'build-env' : 'default',
            rawValue: process.env.REACT_APP_ENVIRONMENT
        };
    }

    const environmentFromQueryParam = getEnvironmentFromSearchParams(window.location.search);

    if (environmentFromQueryParam) {
        return {
            environment: environmentFromQueryParam,
            source: 'query-param',
            rawValue: window.location.search
        };
    }

    const environmentFromHostname = getEnvironmentFromHostname(window.location.hostname);

    if (environmentFromHostname) {
        return {
            environment: environmentFromHostname,
            source: 'hostname',
            rawValue: window.location.hostname
        };
    }

    if (process.env.REACT_APP_ENVIRONMENT) {
        return {
            environment: normalizeEnvironment(process.env.REACT_APP_ENVIRONMENT),
            source: 'build-env',
            rawValue: process.env.REACT_APP_ENVIRONMENT
        };
    }

    return {
        environment: DEFAULT_ENVIRONMENT,
        source: 'default',
        rawValue: null
    };
};

const buildConfig = () => {
    const runtimeEnvironment = getRuntimeEnvironment();
    const selectedConfig = environmentConfig[runtimeEnvironment.environment] || environmentConfig[DEFAULT_ENVIRONMENT];

    return {
        ...sharedConfig,
        ...selectedConfig,
        runtimeEnvironmentSource: runtimeEnvironment.source,
        runtimeEnvironmentRawValue: runtimeEnvironment.rawValue,
        runtimeEnvironmentResolved: selectedConfig.environment
    };
};

export const appConfig = buildConfig();

export const loadRuntimeConfig = async () => {
    window.__APP_CONFIG__ = appConfig;
    return appConfig;
};
